module.exports = __webpack_public_path__ + "media/honey-icons/icon-microphone-off-d9e59213.svg";